// extracted by mini-css-extract-plugin
export var galleryWrapper = "photos-module--gallery-wrapper--1Yy5b";